import Layout from "../components/Layout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {useSelector} from "react-redux";
import {createSearchParams, useNavigate} from "react-router-dom";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import QuarterNames from "../components/QuarterNames";

const EmployeeIDP = () => {
    const [start] = useState(0);
    const [empIdpList, setEmpIdpList] = useState([]);
    const {user} = useSelector((state) => state["auth"]);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const navigate = useNavigate()
    const [quarterName, setQuarterName] = useState("");


    useEffect(() => {
        initFilters();        
        getEmployeeIDPList(user.registerID,user.quarterID)
        setQuarterName(user.quarterName);
    }, [])


    const getEmployeeIDPList = (registerID,quarterID) => {  
        
    const _dbModel={registerId:registerID,quarterId: parseInt(quarterID)}
        axios.post(BASE_URL + "/api/idp/GetIDPEmployeeList/" ,JSON.stringify(_dbModel))
            .then(response => {
                setEmpIdpList(response.data)
            })
            .catch(e => console.log(e))
    }

    const _actionBody = (empIdp) => (<>
      <button type="button" style={{cursor: "pointer",padding:"2px 5px 2px 5px", fontSize:"10pt"}} className="btn btn-outline-primary" onClick={()=>{
          navigate({
              pathname: "/IDPDetails",
              search: createSearchParams({
                  employeeId: empIdp.registerID
              }).toString()
          });
      }}>Create IDP</button>
    </>)
    const _actionIDPBody = (empIdp) => (<>
        {console.log(btoa("category=textile&user=user1"))}
        <div class="btn-group">
            <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                Select
            </button>
            <ul class="dropdown-menu" style={{minWidth:"11rem"}}>
                <li><a style={{fontWeight:"600"}} className="dropdown-item" href="#" 
                onClick={()=>{
                    var e = document.getElementById("ddlQuarter");
                    var _selectedValue = e.value==="-1"?user.quarterID:e.value;

                    window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + empIdp.registerID+"&QuarterID=" + _selectedValue));
                    //window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?SearchStr="+btoa("RegisterID=" + empIdp.registerID+"&QuarterID=" + user.quarterID));    
                    // window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?RegisterID=" + empIdp.registerID+"&&QuarterID=" + user.quarterID);
                    }}><i class="bi bi-person-bounding-box"></i> IDP Report</a>
                </li>
                <li><a style={{fontWeight:"600"}} className="dropdown-item" href="#" 
                onClick={()=>{
                    navigate({
                        pathname: "/IDPDetails",
                        search: createSearchParams({
                            employeeId: btoa(empIdp.registerID)
                        }).toString()
                    });
                    }}><i class="bi bi-pencil-fill"></i> Create IDP</a>
                </li>
                <li><a style={{fontWeight:"600"}} className="dropdown-item" href="#" 
                onClick={()=>{
                    var e = document.getElementById("ddlQuarter");
                    var _selectedValue = e.value==="-1"?user.quarterID:e.value;
                    navigate({
                        pathname: "/EvaluationReport",
                        search: createSearchParams({
                            employeeId: btoa(empIdp.registerID),
                            quarterId:_selectedValue
                        }).toString()
                    });
                    }}><i class="bi bi-person-lines-fill"></i> Evaluation Report</a>
                </li>
            </ul>
        </div>
        {/* <button type="button" style={{cursor: "pointer",padding:"2px 5px 2px 5px", fontSize:"10pt"}} className="btn btn-outline-secondary" onClick={()=>{
            window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/IndividualPerformanceReport?RegisterID=" + empIdp.registerID);
        }}>IDP Report</button> */}
      </>)
    const _actionReportBody = (empIdp) => (<>
        <button type="button" style={{cursor: "pointer",padding:"2px 5px 2px 5px", fontSize:"10pt"}} className="btn btn-outline-secondary" onClick={()=>{
            navigate({
                pathname: "/EvaluationReport",
                search: createSearchParams({
                    employeeId: empIdp.registerID
                }).toString()
            });
        }}>Evaluation Report</button>
      </>)

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }


    const initFilters = () => {
        setFilters({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue('');
    }
    const clearFilter = () => {
        initFilters();
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilter}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange}
                               placeholder="Keyword Search"/>
                </span>
                </div>
            </div>
        </div>
    );

    const childToParent = () => {
        var e = document.getElementById("ddlQuarter");
        var _selectedValue = e.value==="-1"?user.quarterID:e.value;
        setQuarterName(e.value==="-1"?user.quarterName:e.options[e.selectedIndex].text); 
        getEmployeeIDPList(user.registerID,_selectedValue);       
      }
    

    return (<Layout>

        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6><i class="bi bi-person-check"></i> Employee List</h6>
                <h4> <QuarterNames childToParent={childToParent}/></h4>
            </div>
            <div className="card-body">
                <DataTable value={empIdpList} header={header} paginator rows={7} first={start}
                globalFilterFields={['employeeCode','employeeName', 'department', 'designation']}
                filters={filters}
                dataKey="registerID"
                           paginatorTemplate=" PageLinks  ">
                    <Column field="registerID" header="registerID" hidden={true}/>
                    <Column field='employeeCode' style={{width:"13%"}} sortable alignHeader="center" header="Emp Code"/>
                    <Column field='employeeName' sortable alignHeader="center" header="Employee Name"/>
                    <Column field='department' sortable alignHeader="center" header="Department"/>
                    <Column field='designation' sortable alignHeader="center" header="Designation"/>
                    <Column field="registerID" style={{width:"10%"}} align="center" alignHeader="center" header="Action" body={_actionIDPBody}/>
                    {/* <Column field="registerID" style={{width:"120px"}} align="center" alignHeader="center" header="Action" body={_actionBody}/>
                    <Column field="registerID" style={{width:"150px"}} align="center" alignHeader="center" header="Action" body={_actionReportBody}/> */}
                </DataTable>
            </div>
        </div>

    </Layout>)
}


export default EmployeeIDP